<template>
  <div class="fragmented-verse" :class="{'has-ref': fragmentedVerse.ref && fragmentedVerse.ref.length > 0}">
    <div class="characters">
      <div v-for="character in fragmentedVerse.elements" class="fragmented-character">
        <div class="name">
          <ref v-if="character.ref" :id="character.ref"/>
          {{character.name}}
        </div>
        <ref v-if="fragmentedVerse.ref && fragmentedVerse.ref.length > 0" :id="fragmentedVerse.ref">
          <verse :verse="character.verse" :number="false"/>
        </ref>
        <verse v-else :verse="character.verse" :number="false"/>
      </div>
    </div>
    <div class="number" v-if="fragmentedVerse.verse_index.start % 5 === 0">{{fragmentedVerse.verse_index.start}}</div>
  </div>
</template>
<script>
  import Verse from './Verse'
  import Ref from './Ref'

  export default {
    components: {Ref, Verse},
    props: {
      fragmentedVerse: {type: Object, required: true}
    }
  }
</script>
<style lang="scss">
// Non-scoped style to handle fragmented-verse stage-direction position
// Note: Never use scoped component styles again D:, use global scss folder instead next time
.fragmented-verse .characters .fragmented-character .verse {
  position: relative;

  .stage-direction {
    position: absolute;
    white-space: normal; // Multiline stage direction WILL overlap verse below
    width: 50vw;

    // Equivalent to: @include media-breakpoint-up(xl)
    @media (min-width: 1200px) {
      width: 25vw; // Workaround for the width of the stage direction
    }
  }
}
</style>
<style lang="scss" scoped>
  @import "app/javascript/scss/variables";

  .fragmented-verse {
    position: relative;
    margin-left: $character-name-separation;

    .name {
      position: absolute;
      width: $character-name-width;
      left: -$character-name-separation;
      font-weight: bold;
      text-align: right;

      .ref {
        display: inline-block
      }
    }

    .number {
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .characters {
      display: flex;
      align-items: start;
      margin-left: $character-name-width;

      .fragmented-character .verse {
        display: inline; // Required to position popover correctly.
        white-space: nowrap;
      }

      @for $i from 0 through 5 {
        .fragmented-character:nth-child(#{$i + 1}) {
          margin-top: #{20 * $i}px;
        }
      }
    }

    &.has-ref {
      > .ref {
        position: absolute;
        right: calc(100% - #{$character-name-width});
      }
    }
  }
</style>
